/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/

/* eslint-disable prefer-arrow-functions/prefer-arrow-functions */
import { CoreCustomPageType, CorePageReviewRendererType } from '../../../class/workflow.type';
import { workflowModalRegistry, workflowPageRegistry } from '../../shared/workflow-registries';

export function CoreCustomPageReviewRenderer(reviewRendererType: CorePageReviewRendererType) {
  return (target) => CustomPageBase(reviewRendererType, target);
}

/** Custom Page decorator */
export function CoreCustomPage(pageType: CoreCustomPageType) {
  return (target) => CustomPageBase(pageType, target);
}

export function CustomModal(pageType: string) {
  return (target) => CustomPageBase(pageType, target, workflowModalRegistry);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function CustomPageBase<T>(customPageType: CoreCustomPageType | T, target, registry: {} = workflowPageRegistry) {
  const pageType = customPageType as string;
  if (!registry[pageType]) {
    registry[pageType] = target;
  }
}
